import { useCallback, useEffect, useState } from "react";
import { CredentialWithId, DetailsCardItem } from "../types/credentialTypes";
import { buildCredentialDetailsData } from "../utils/buildCredentialDetailsData";

interface UseCredentialSelectionArgs {
  credentials: CredentialWithId[] | null;
  selectedClientId: string | null;
  urlId?: string;
}

/**
 * Owns the currently selected credential lifecycle for the credentials
 * configuration page: the selected id, the underlying credential object,
 * and the cards-data view-model derived from it.
 */
export const useCredentialSelection = ({
  credentials,
  selectedClientId,
  urlId,
}: UseCredentialSelectionArgs) => {
  const [selectedCredentialId, setSelectedCredentialId] = useState<
    string | null
  >(null);
  const [credentialDetails, setCredentialDetails] =
    useState<CredentialWithId | null>(null);
  const [detailsCardData, setDetailsCardData] = useState<DetailsCardItem[]>([]);

  const selectCredential = useCallback((credential: CredentialWithId) => {
    if (credential?.id) {
      setSelectedCredentialId(credential?.id);
      setCredentialDetails(credential);
    }
  }, []);

  const resetSelection = useCallback(() => {
    setSelectedCredentialId(null);
    setCredentialDetails(null);
  }, []);

  useEffect(() => {
    if (credentialDetails) {
      setDetailsCardData(buildCredentialDetailsData(credentialDetails));
    }
  }, [credentialDetails]);

  return {
    selectedCredentialId,
    credentialDetails,
    detailsCardData,
    selectCredential,
    resetSelection,
  };
};
